module.exports = __webpack_public_path__ + "static/media/bearings5.ac1c2236.jpg";